const getAvatarName = (name: string, length = 2) => {
  if (!name) return null;

  const names = name.split(' ');

  // first letter of first name
  let initials = names[0].substring(0, 1).toUpperCase();

  // if there are two names, add the first letter of the last name
  if (names.length > 1 && initials.length < 2) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  } else {
    // else if only one name, add the first two letters of the name
    initials = names[0].substring(0, 2).toUpperCase();
  }

  return initials.substring(0, length);
};

export default getAvatarName;
